import { Controller } from "@hotwired/stimulus"

// Formularz raportu whitelabel: wybor sposobu oplaty i dopisywanie zmian stawki
export default class extends Controller {
  static targets = ["feeKindCard", "ownFee", "priceListDiscount", "priceChanges", "priceChangeTemplate"]
  static classes = ["selectedCard", "unselectedCard"]
  static values = { newIndex: String }

  // podswietlenie karty daje CSS (has-[:checked]); tu utrzymujemy znacznik wybranego trybu i blokade stawki wlasnej
  switchFeeKind(event) {
    this.feeKindCardTargets.forEach(card => {
      const selected = card.querySelector("input[type=radio]").checked

      card.classList.toggle(this.selectedCardClass, selected)
      card.classList.toggle(this.unselectedCardClass, !selected)
    })

    // brak targetu = stawka zablokowana serwerowo, bo raport ma juz wlasna stawke
    if (this.hasOwnFeeTarget) {
      this.ownFeeTarget.disabled = event.currentTarget.value !== "own"
    }

    // rabat schodzi wylacznie z ceny cennikowej
    if (this.hasPriceListDiscountTarget) {
      this.priceListDiscountTarget.disabled = event.currentTarget.value !== "price_list"
    }
  }

  addPriceChange() {
    const index = this.priceChangesTarget.children.length
    const row = this.priceChangeTemplateTarget.innerHTML.replaceAll(this.newIndexValue, index)

    this.priceChangesTarget.insertAdjacentHTML("beforeend", row)
  }
}
